module.exports = ".dropdown-toggle{\r\n    cursor: pointer;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/bs-navbar/bs-navbar.component.css
// module id = ./src/app/core/components/bs-navbar/bs-navbar.component.css
// module chunks = main